export default __webpack_public_path__ + "static/media/chat.54cb39a4.svg";